import * as React from "react";

import twMerge from "@replo/design-system/utils/twMerge";

type ComboboxFooterProps = React.PropsWithChildren<{
  size: "sm" | "base";
}>;

export function ComboboxFooter({ children, size }: ComboboxFooterProps) {
  if (!children) {
    return null;
  }

  return (
    <div
      className={twMerge(
        "border-border border-t",
        size === "sm" ? "px-2 py-2 text-xs" : "px-3 py-3 text-sm",
      )}
    >
      {children}
    </div>
  );
}
